var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTutorialUpCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 338,
    height: 211,
    viewBox: "0 0 338 211",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Tracciato_1564",
    x: 116,
    y: 0,
    width: 106,
    height: 27,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 9,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rettangolo_476",
    x: 0,
    y: 9,
    width: 338,
    height: 202,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 9,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_982",
    "data-name": "Raggruppa 982",
    transform: "translate(-1775 -1351)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1775, 1351)",
    filter: "url(#Tracciato_1564)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1564-2",
    "data-name": "Tracciato 1564",
    d: "M574,22H536.92l-7.42-9-7.792,9H574Z",
    transform: "translate(-367 -13)",
    fill: "#6466f1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1775, 1351)",
    filter: "url(#Rettangolo_476)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_476-2",
    "data-name": "Rettangolo 476",
    width: 320,
    height: 184,
    rx: 9,
    transform: "translate(3 9)",
    fill: "#6466f1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorialUpCenter);
export default __webpack_public_path__ + "static/media/tutorial-up-center.dff38ac376ee9f15cac81e5b441c3e70.svg";
export { ForwardRef as ReactComponent };